export default {
    NODE_ENV: process.env.REACT_APP_ENV,
    INSTANCE_NAME: process.env.REACT_APP_INSTANCE,
    SETTINGS: require(`./${process.env.REACT_APP_INSTANCE}_settings.json`),
}

